import {OpeningHours} from '@flowmaps-com/flowmaps-typescriptmodels';

export interface OpeningHoursRow {
    dayOfWeek: any;
    start: any;
    end: any;
    closed: boolean;
    inherited: boolean;
}

export function resolveOpeningHoursRows(days: string[], overrides: OpeningHours[] = [],
                                        explicitlyClosedDays: string[] = [], defaults: OpeningHours[] = []): OpeningHoursRow[] {
    const defaultsConfigured = defaults.length > 0;
    return days.map(dayOfWeek => {
        const override = overrides.find(hours => hours.dayOfWeek === dayOfWeek);
        if (override) {
            return row(dayOfWeek, override.start, override.end, false, false);
        }
        if (explicitlyClosedDays.includes(dayOfWeek)) {
            return row(dayOfWeek, null, null, true, false);
        }
        const defaultHours = defaults.find(hours => hours.dayOfWeek === dayOfWeek);
        if (defaultHours) {
            return row(dayOfWeek, defaultHours.start, defaultHours.end, false, true);
        }
        return row(dayOfWeek, null, null, defaultsConfigured, true);
    });
}

export function locationOpeningHourOverrides(rows: OpeningHoursRow[]): OpeningHours[] {
    return rows.filter(day => !day.inherited && !day.closed && !!day.start && !!day.end && day.start !== day.end)
        .map(day => ({dayOfWeek: day.dayOfWeek, start: day.start, end: day.end} as unknown as OpeningHours));
}

export function explicitlyClosedOpeningDays(rows: OpeningHoursRow[]): any[] {
    return rows.filter(day => !day.inherited && day.closed).map(day => day.dayOfWeek);
}

function row(dayOfWeek: string, start: any, end: any, closed: boolean, inherited: boolean): OpeningHoursRow {
    return {dayOfWeek, start, end, closed, inherited};
}
